import React, { useEffect, useState } from "react";
import { CompanyImage, ShareModal } from "./PaymentHistory";
import {
  TelegramIcon,
  TelegramShareButton,
  WhatsappIcon,
  WhatsappShareButton,
  EmailShareButton,
  EmailIcon,
} from "react-share";
import { toast } from "react-toastify";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { ReactComponent as Copy } from "../../assets/icons/copy.svg";
import { ReactComponent as Eye } from "../../assets/icons/eye.svg";
import { ReactComponent as SMS } from "../../assets/icons/sms.svg";
import { ReactComponent as LOGO } from "../../assets/icons/Group 1.svg";
import { ReactComponent as PDF } from "../../assets/icons/PDFEXPORT.svg";
import { ReactComponent as Share } from "../../assets/icons/share.svg";
import PhoneHeader from "../../Components/Common/PhoneHeader";
import { useHistory } from "react-router-dom";
const moment = require("moment-jalaali");
const ProfileInfo = ({ name, text }) => {
  return (
    <div>
      <span>{text}</span>
      <span>{name}</span>
    </div>
  );
};

const PaymentComponent = ({
  name,
  cost,
  billId,
  date,
  companyId,
  trace,
  period,
  link,
  cardNum,
  index,
}) => {
  const periodFunc = () => {
    if (period == 0) {
      return "میان دوره";
    } else {
      return "پایان دوره";
    }
  };
  const [copied, setCopied] = useState(false);
  const [share, setShare] = useState(false);

  useEffect(() => {
    if (copied) {
      toast.success("لینک با موفقیت کپی شد", {
        position: "bottom-center",
      });
      setCopied(false);
    }
  }, [copied]);
  return (
    <div
      id="Billhistory"
      key={index}
      style={{ animationDelay: `${index * 0.1}s` }}
      className={
        share ? "PaymentComponentContainerOpen" : "PaymentComponentContainer"
      }
    >
      <div className="PaymentComponentContainerInner">
        <div className="CompanyImageHistory">
          <img src={CompanyImage(companyId)} alt="" />
        </div>
        <div>
          <ProfileInfo name={"نام مشترک"} text={name} />

          <ProfileInfo name={"نوع قبض"} text={periodFunc()} />

          {cardNum && cardNum !== null && (
            <ProfileInfo name={"شماره کارت"} text={cardNum} />
          )}
          {/* <ProfileInfo name={"شماره کارت"} text={"cardNum"} /> */}
          <ProfileInfo name={"مبلغ"} text={` ${cost} ریال`} />
          <ProfileInfo name={"شناسه قبض"} text={billId} />
          <ProfileInfo name={"شماره پیگیری"} text={trace} />
          <ProfileInfo name={"تاریخ پرداخت"} text={date} />
        </div>
      </div>

      <div className="PaymentComponentDesc">
        <LOGO />
        <span>{`کنتور، مدیریت هوشمند قبوض شرکت های خدماتی`}</span>
      </div>
      <div className="Links">
        <div
          className="LinkComponent"
          onClick={() => {
            window.open(link, "_blank");
            setShare(false);
          }}
        >
          <Eye /> <span>مشاهده لینک</span>
        </div>

        <div
          className="LinkComponent"
          onClick={() => {
            setShare(!share);
          }}
        >
          <Share /> <span>اشتراک گذاری</span>
        </div>

        <CopyToClipboard
          text={`${link}`}
          onCopy={() => {
            setCopied(true);
            setShare(false);
          }}
        >
          <div className="LinkComponent">
            <Copy /> <span>کپی لینک</span>
          </div>
        </CopyToClipboard>
      </div>

      <div
        className={share ? "ShareContainOpen" : "ShareContain"}
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-evenly",
          alignItems: "center",
        }}
      >
        <li>
          <a href={`sms:?&body=${link}`}>
            <SMS />
          </a>
        </li>
        <TelegramShareButton
          url={link}
          children={<TelegramIcon round={true} />}
        />
        <WhatsappShareButton
          url={link}
          children={<WhatsappIcon round={true} />}
        />
        {/* <EmailShareButton url={link} children={<EmailIcon round={true} />} /> */}
      </div>
    </div>
  );
};

function SingleBillHistory({ location }) {
  const history = location?.state || null;
  const History = useHistory();
  useEffect(() => {
    if (!history) {
      console.log("dklgn ln gg");
      History.goBack();
    }
  }, [history]);

  const [visible, setVisible] = useState(false);
  //   const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [companyId, setCompanyId] = useState(0);
  const [shareURL, setShareURL] = useState(false);
  const filteredHistory = history;
  return (
    <div className="Container">
      <div
        className="mobileContainer"
        style={{ paddingTop: window.innerHeight * 0.1 }}
      >
        <PhoneHeader text="سوابق پرداخت" />
        {loading && (
          <img
            id="loading"
            className="LoadingImage"
            src={require("../../assets/images/Loading.png")}
          />
        )}
        {!loading && filteredHistory?.length === 0 && companyId !== 0 && (
          <div
            style={{
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
              width: "100%",
            }}
          >
            <span className="historySpanEmpty">
              !موردی برای نمایش وجود ندارد
            </span>
          </div>
        )}
        {!loading && filteredHistory?.length !== 0 && (
          <>
            <div className="PdfExort">
              <PDF />
              <span>از پرداخت‌ها PDF خروجی</span>
            </div>
            <div className="divider" />
            <div className="paymentsContainer" id="paymentsContainer">
              {filteredHistory.map((i, index) => {
                const billInfo = i.user_bill;
                return (
                  <PaymentComponent
                    setVisible={setVisible}
                    setShareURL={setShareURL}
                    index={index}
                    key={`#History${index}`}
                    name={billInfo.parameter_title}
                    cost={billInfo.amount.toLocaleString()}
                    cardNum={i.card_number}
                    link={`https://dev.mycontor.ir/Bill/${i.invoice_number}`}
                    billId={billInfo.bill_id}
                    trace={i.rrn}
                    period={billInfo.end_of_period}
                    date={moment(billInfo.paid_at).format("jD / jM /jYYYY ")}
                    companyId={billInfo.bill_company_id}
                  />
                );
              })}
            </div>
          </>
        )}
        {visible && <ShareModal setVisible={setVisible} shareURL={shareURL} />}
      </div>
    </div>
  );
}

export default SingleBillHistory;
